<template>
  <div class="main">
    <div class="content">
      <ul
        style="
          display: flex;
          justify-content: space-around;
          font-size: 14px;
          height: 40px;
        "
      >
        <li
          ref="merchant"
          class="invite-type"
          :class="merchantselected"
          @click="isMerchant && select('merchant')"
        >
          {{ $t('invitePage.merchant') }}
        </li>
        <li class="invite-type" :class="shopselected" @click="select()">
          {{ $t('common.shop') }}
        </li>
      </ul>
      <component :is="childComponent" ref="childComp" @invite="invite"></component>
    </div>
  </div>
</template>
<style scoped>
/* .main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 80px;
} */
.main {
  width: 100%;
  height: calc(100% - 120px);
  overflow: auto;
  padding-top: 80px;
}

.content {
  margin: 0 auto;
  color: #3d4d6b;
  height: 380px;
  width: 380px;
}
.invite-type {
  flex: 0 0 50%;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
  background-color: white;
  border-radius: 8px 8px 0px 0px;
}
.invite-selected {
  background-color: #c6cbd1;
  margin-bottom: -1px;
}
@media (max-width: 1240px) {
  .main {
    height: calc(100% - 120px);
    overflow: auto;
  }
}

@media (max-width: 747px) {
  .content {
    height: 360px;
    width: 360px;
  }
}

@media (max-width: 420px) {
  .content {
    width: 350px;
  }
}

@media (max-width: 321px) {
  .content {
    width: 310px;
  }
}
</style>
<script>
import InviteShop from '../../components/InviteShop';
import InviteMerchant from '../../components/InviteMerchant';

export default {
  name: 'Invite',
  data() {
    return {
      merchantselected: 'invite-selected',
      shopselected: '',
      childComponent: InviteMerchant,
      isMerchant: true
    };
  },
  components: { InviteShop, InviteMerchant },
  methods: {
    select(param) {
      if (param === 'merchant') {
        this.merchantselected = 'invite-selected';
        this.shopselected = '';
        this.childComponent = InviteMerchant;
      } else {
        this.merchantselected = '';
        this.shopselected = 'invite-selected';
        this.childComponent = InviteShop;
      }
    },
    invite(p) {
      let user = this.$store.getters.get_user_Info_cache;
      if (!user) {
        return;
      }
      let obj = {
        email: p.email,
        firstName: p.firstName,
        lastName: p.lastName,
        faxCountryCode: p.faxCountryCode,
        fax: p.fax,
        mobileCountryCode: p.mobileCountryCode,
        mobileNumber: p.mobileNumber,
        phoneCountryCode: p.phoneCountryCode,
        phoneNumber: p.phoneNumber
      };
      if (!p.email) {
        this.$message.info(this.$t('invitePage.error.needEmail'));
        return;
      } else if (!p.firstName || p.firstName.length > 20) {
        if (p.firstName.length > 20) {
          this.$message.info(this.$t('invitePage.error.nameTooLong'));
        } else {
          this.$message.info(this.$t('invitePage.error.needName'));
        }
        return;
      } else if (!p.lastName || p.lastName.length > 20) {
        if (p.lastName.length > 20) {
          this.$message.info(this.$t('invitePage.error.nameTooLong'));
        } else {
          this.$message.info(this.$t('invitePage.error.needName'));
        }
        return;
      }
      if (p.name == 'InviteMerchant') {
        obj.isMerchantInvitation = true;
        obj.merchantId = user.merchantId;
        obj.targetShop = {};
      } else if (p.name == 'InviteShop') {
        if (!p.targetShop) {
          this.$message.info(this.$t('invitePage.error.needShop'));
          return;
        }
        obj.isMerchantInvitation = false;
        obj.merchantId = '';
        obj.targetShop = p.targetShop;
      }
      //verfiy parameter
      // eslint-disable-next-line
      // let reg = /^([a-zA-Z]|[0-9])(\w|\-|\.|\+)+@([a-zA-Z]|[0-9])(\w|\-|\.)+(\.([a-zA-Z]{2,4}))+$/;
      let reg =  /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!reg.test(p.email)) {
        this.$message.info(this.$t('invitePage.error.emailIncorrect'));
        return;
      }
      this.$refs.childComp.loading = true;
      let self = this;
      this.$axios
        .post('/Invitation', obj)
        .then(function (res) {
          self.$refs.childComp.loading = false;
          //console.log(res);
          self.$refs.childComp.InvitationQuota = res;
          self.$message.success(self.$t('invitePage.succeed'));
        })
        .catch(() => {
          self.$refs.childComp.loading = false;
        });
    },
    InvitationQuota() {
      let self = this;
      this.$axios.get('/Invitation/availableNumber').then(function (res) {
        // 动态组件 <component :is> 切换时 ref 可能短暂为 null,加防御避免报错
        if (!self.$refs.childComp) return;
        self.$refs.childComp.InvitationQuota = res;
        if (res && res < 1) self.$refs.childComp.isdisabled = true;
        else self.$refs.childComp.isdisabled = false;
      });
    }
  },
  mounted() {
    let user = this.$store.getters.get_user_Info_cache;
    if (user) {
      // 等动态组件渲染完成后再请求,避免 $refs.childComp 为 null
      this.$nextTick(() => {
        this.InvitationQuota();
      });

      if (user.isMerchant) {
        this.select('merchant');
      } else {
        this.select();
        this.isMerchant = false;
        this.$refs.merchant.innerHTML = '';
      }
    }
  }
};
</script>
